
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opleidingen/[uid]/studiegids-aanvragen",
      function () {
        return require("private-next-pages/opleidingen/[uid]/studiegids-aanvragen.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opleidingen/[uid]/studiegids-aanvragen"])
      });
    }
  